// removed by extract-text-webpack-plugin
module.exports = {"icon":"_2awO8pV4azWUWNWOMGt8RD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Link/Link.module.scss
// module id = 782
// module chunks = 0